import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './../App.css';
import timelineElements from './timelineElements';
import timelineElementsESP from './timelineElementsESP';
import { franc } from 'franc-min';
// import voiceIcon from '../assets/img/voice.png';
import languagesIcon from '../assets/img/languages.svg';

const technicalFAQsEN = [
    { question: "Where are you from?" },
    { question: "Tell me about yourself" },
    { question: "Carlos Evolution" },
    { question: "Projects and Skills" }
];

const technicalFAQsES = [
    { question: "¿De dónde eres?" },
    { question: "Cuéntame sobre ti" },
    { question: "Evolución de Carlos" },
    { question: "Proyectos y habilidades" }
];

const techKnowledgeBase = {
    "hello": "Hello! What would you like to know about Carlos?",
    "how are you": "Hello, Carlos is really happy to see you here! \n\n If you want to know more about him, you can always ask about any technology that interests you, and you'll discover if he's worked on it! Have a great day!",
    "where are you from": "Hello, Carlos is from Spain but is developing his professional career in the UK.",
    "like working on the most": "Carlos enjoys working on innovative technological projects that involve new technologies and challenging experiences.\n If you have similar interests or are interested in his talent, send him an email!",
    "what is your work experience?": "Carlos has a diverse background in software engineering and data-focused roles. He worked as a freelancer on multiple projects, leveraging his expertise in data analysis and AI. Additionally, he completed an internship at a small company, focusing on databases and data manipulation. At Edinburgh Napier University, Carlos provided real-time assistance to students, helping them tackle practical problems in data management and processing, optimizing database queries, and handling large-scale data while guiding them on best practices. Beyond tech, he has experience as a food delivery driver and in food catering services, showcasing his adaptability and work ethic. As a public speaker with ~20 talks in 2019 and a community contributor organizing tech events, Carlos brings a unique blend of technical and leadership skills.",
    "describe yourself": "Hello!\n\n Carlos is an empathetic and grateful person, interested in both linguistic languages and programming languages. He loves working in teams finding joint solutions, although he also feels very efficient working autonomously.<br></br> He is also very athletic: he is passionate about playing tennis, paddle, and soccer, as well as watching them. Thanks for your interest!",
    "tell me about yourself": "Carlos is a software engineer who enjoys developing technological solutions in various areas, including Blockchain, Artificial Intelligence, DevOps, Data Analysis, and Full-Stack development. He is currently more focused on AI and Data Analysis after completing a Master's in Computer Science. \n He enjoys learning continuously and applying his knowledge to real projects that generate impact, as well as working in teams, sharing ideas, and finding collaborative solutions to problems. \n Being fluent in English and Spanish allows him to communicate with people from different countries and participate in international environments, both academic and professional.",
    "evolution": "Great question! Carlos grew up in Spain and, at 14 years old, decided to go to the United States to complete a school year in Maryland, where he learned a lot by getting to know different cultures. He left with a very low level of English, which was a challenge he enjoyed, because he loves setting challenging goals for personal and professional growth. \n\n Finally, he finished school and went to Edinburgh to study software engineering, which he completed course by course, also being a great personal challenge. \n Not long ago, he obtained a master's in computer science to acquire more knowledge and experience; in this way, he is discovering in which sector he likes to work the most, such as data analysis & processing, as well as artificial intelligence.",
    "hola": "¡Hola! ¿Que te gustaria saber sobre Carlos?",
    "buenas": "¡Hola! ¿En qué puedo ayudarte hoy acerca de Carlos?",
    "como estas": "Hola, ¡Carlos está muy feliz de verte aquí! \n Si quieres saber más sobre él, siempre puedes preguntar sobre cualquier tecnología que te interese y descubrir si ha trabajado en ella. ¡Que tengas un gran día!",
    "de donde eres": "Hola, Carlos es de España pero está desarrollando su carrera profesional en Reino Unido.",
    "que te gusta trabajar mas": "Carlos disfruta trabajando en proyectos tecnológicos innovadores que involucran nuevas tecnologías y experiencias desafiantes.\n También le encanta jugar y ver tenis, pádel y fútbol. ¡Envíale un correo si compartes intereses similares!",
    "describete": "Carlos es un ingeniero de software que disfruta desarrollar soluciones tecnológicas en diversas áreas, incluyendo Blockchain, Inteligencia Artificial, DevOps, Análisis de Datos y desarrollo Full-Stack; actualmente se enfoca principalmente en IA y Análisis de Datos, tras completar un máster en Ciencias de la Computación. \nDisfruta aprendiendo continuamente y aplicando sus conocimientos a proyectos del mundo real que generan impacto, además de trabajar en equipo, compartir ideas y encontrar soluciones colaborativas a los problemas. \nHablar inglés con fluidez le permite comunicarse con personas de diferentes países y participar en entornos internacionales, tanto académicos como profesionales.",
    "trayectoria": "Buena pregunta, Carlos creció en España y a los 14 años decidió irse a EEUU para hacer un año de colegio en Maryland, donde creció muchísimo conociendo diferentes culturas. Se fue con un nivel muy bajo de inglés, lo cual fue más desafiante para él, algo que le encanta: ponerse objetivos desafiantes y de crecimiento tanto personal como profesional. \n\n Finalmente terminó el colegio y se fue a Edimburgo a estudiar la carrera de ingeniería de software, la cual completó curso a curso, siendo también un gran desafío personal. \n Hace poco obtuvo un máster en ciencias de la computadora para obtener más conocimiento y experiencia; de esta manera está descubriendo en qué sector le gusta más trabajar, como el análisis y procesamiento de datos, así como la inteligencia artificial.",
    "database": "Worked with SQL (PostgreSQL, MySQL) and NoSQL (MongoDB, Redis) databases. Optimized queries and implemented caching strategies.",
    "query performance prediction (QPP)": "As part of his Master's dissertation, Carlos is researching and implementing Query Performance Prediction (QPP) techniques to optimize big data queries. The goal is to improve the efficiency of user data retrieval and processing by leveraging machine learning models to predict query execution times, optimize resource allocation, and enhance database performance in large-scale distributed systems.",
    "Work experience": "Worked as a university demonstrator for 4 months in the 'Data Management & Processing' course. Provided real-time assistance to students, helping them solve practical problems related to data management and processing. Offered solutions to technical challenges involving databases, query optimization, and handling large-scale data. Additionally, guided students in resolving conceptual doubts and implementing best practices in data processing."
};

const INTRO_MESSAGES = {
    en: "Hello! I'm here to introduce **Carlos Jiménez Rodríguez**, a Software Engineer with a Master's in Computer Science and Bachelor's in Software Engineering at **Edinburgh Napier University**, specializing in data analysis & processing and artificial intelligence daily. \n\nYou can ask me about his projects, work experience, technical skills, or community contributions to discover how he can drive value for your team!",
    es: "¡Hola! Estoy aquí para presentarte a **Carlos Jiménez Rodríguez**, un Ingeniero de Software con Maestría en Ciencias de la Computación y Licenciatura en Ingeniería de Software en la **Universidad Napier de Edimburgo**, especializándose en análisis y procesamiento de datos e inteligencia artificial diariamente. \n\nPuedes preguntarme sobre sus proyectos, experiencia laboral, habilidades técnicas o contribuciones comunitarias para descubrir cómo puede aportar valor a tu equipo!"
};

const MAX_INPUT_CHARACTERS = 250;
const MAX_TOKEN_ESTIMATE = 500;

const normalizeText = (text) =>
    text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

const formatTimelineResponse = (projects) => {
    const MAX_PROJECTS = 3;
    let response = "From my technical timeline:\n\n";
    projects.slice(0, MAX_PROJECTS).forEach(proj => {
        response += `• ${proj.title} (${proj.date}): ${proj.description}\n`;
        response += `Technologies: ${proj.tags?.join(', ') || 'Various'}\n\n`;
    });
    response += "Would you like details on any specific project?";
    return response;
};

const searchTimeline = (query) => {
    const normalizedQuery = normalizeText(query);
    return timelineElements.filter(element => {
        const content = normalizeText(`${element.title} ${element.description} ${element.tags?.join(' ') || ''}`);
        return content.includes(normalizedQuery);
    });
};

const searchTimelineESP = (query) => {
    const normalizedQuery = normalizeText(query);
    return timelineElementsESP.filter(element => {
        const content = normalizeText(`${element.title} ${element.description} ${element.tags?.join(' ') || ''}`);
        return content.includes(normalizedQuery);
    });
};

const retrieveTechResponse = (query) => {
    const normalizedQuery = normalizeText(query);
    for (const [key, value] of Object.entries(techKnowledgeBase)) {
        if (normalizedQuery.includes(key)) return value;
    }
    // Skip timeline search for very short queries to allow LLM to handle conversational follow-ups
    if (normalizedQuery.length < 3) return null;
    const timelineResults = searchTimeline(normalizedQuery);
    if (timelineResults.length > 0) {
        return formatTimelineResponse(timelineResults);
    }
    const timelineResultsESP = searchTimelineESP(normalizedQuery);
    if (timelineResultsESP.length > 0) {
        return formatTimelineResponse(timelineResultsESP);
    }
    return null;
};

const detectLanguage = (text) => {
    const lang = franc(text);
    return lang === 'spa' ? 'es' : 'en';
};

const estimateTokens = (text) => Math.ceil(text.length / 4);

const validateInput = (text) => {
    const charCount = text.length;
    const estimatedTokens = estimateTokens(text);
    if (charCount > MAX_INPUT_CHARACTERS) {
        return {
            valid: false,
            message: `Input too long! Please limit to ${MAX_INPUT_CHARACTERS} characters. Current: ${charCount}`
        };
    }
    if (estimatedTokens > MAX_TOKEN_ESTIMATE) {
        return {
            valid: false,
            message: `Input too long! Estimated tokens: ${estimatedTokens}/${MAX_TOKEN_ESTIMATE}`
        };
    }
    return { valid: true, message: '' };
};

const ChatCJR = ({ language: languageProp, onLanguageChange } = {}) => {
    // Debug: Check if ElevenLabs API key is loaded
    // console.log('ElevenLabs API key loaded:', !!process.env.REACT_APP_ELEVENLABS_API_KEY, 'key preview:', process.env.REACT_APP_ELEVENLABS_API_KEY ? process.env.REACT_APP_ELEVENLABS_API_KEY.substring(0, 10) + '...' : 'none');
    
    const [language, setLanguageState] = useState(() => {
        const savedLanguage = localStorage.getItem('language');
        return languageProp || savedLanguage || 'en';
    });

    useEffect(() => {
        if (languageProp && languageProp !== language) {
            setLanguageState(languageProp);
        }
    }, [languageProp, language]);

    const location = useLocation();
    const navigate = useNavigate();

    const [messages, setMessages] = useState([]);
    const skipIntroRef = useRef(Boolean(location.state?.prompt));

    const [input, setInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const chatBoxRef = useRef(null);
    const scrollChatToBottom = useCallback((behavior = 'smooth') => {
        if (chatBoxRef.current) {
            chatBoxRef.current.scrollTo({
                top: chatBoxRef.current.scrollHeight,
                behavior
            });
        }
    }, []);
    const [showFAQs, setShowFAQs] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [speechEnabled, setSpeechEnabled] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [isListening, setIsListening] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [isSpeaking, setIsSpeaking] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [showVoicePanel, setShowVoicePanel] = useState(false);

    const [showLanguageMenu, setShowLanguageMenu] = useState(false);
    const languageMenuRef = useRef(null);

    const handleLanguageButtonClick = useCallback(() => {
        setShowLanguageMenu(prev => !prev);
    }, []);

    const applyLanguageChange = useCallback((nextLanguage) => {
        if (!nextLanguage) return;
        if (nextLanguage === language) {
            setShowLanguageMenu(false);
            return;
        }
        // Clear chat messages and reset intro flag when changing language
        setMessages([]);
        skipIntroRef.current = false;
        setLanguageState(nextLanguage);
        localStorage.setItem('language', nextLanguage);
        if (onLanguageChange) {
            onLanguageChange(nextLanguage);
        }
        setShowLanguageMenu(false);
    }, [language, onLanguageChange]);

    useEffect(() => {
        if (!showLanguageMenu) return;
        const handleClickOutside = (event) => {
            if (languageMenuRef.current && !languageMenuRef.current.contains(event.target)) {
                setShowLanguageMenu(false);
            }
        };
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setShowLanguageMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [showLanguageMenu]);

    const isListeningRef = useRef(false);
    const isSpeakingRef = useRef(false);
    const speechEnabledRef = useRef(false);
    const showVoicePanelRef = useRef(false);
    const resumeListeningTimeoutRef = useRef(null);
    const handleUserInputRef = useRef(() => {});

    const clearResumeListeningTimeout = useCallback(() => {
        if (resumeListeningTimeoutRef.current) {
            clearTimeout(resumeListeningTimeoutRef.current);
            resumeListeningTimeoutRef.current = null;
        }
    }, []);

    const hasSentPromptRef = useRef(false);
    const abortControllerRef = useRef(null);
    // eslint-disable-next-line no-unused-vars
    const recognitionRef = useRef(null);
    const audioRef = useRef(null);
    const audioUrlRef = useRef(null);
    const ttsAbortControllerRef = useRef(null);
    // eslint-disable-next-line no-unused-vars
    const speechSessionRef = useRef(0);

    const GROQ_API_KEY = process.env.REACT_APP_GROQ_API_KEY;
    const GROQ_ENDPOINT = "https://api.groq.com/openai/v1/chat/completions";

    useEffect(() => {
        isListeningRef.current = isListening;
    }, [isListening]);

    useEffect(() => {
        isSpeakingRef.current = isSpeaking;
    }, [isSpeaking]);

    useEffect(() => {
        speechEnabledRef.current = speechEnabled;
    }, [speechEnabled]);

    useEffect(() => {
        showVoicePanelRef.current = showVoicePanel;
    }, [showVoicePanel]);

    useEffect(() => {
        return () => {
            clearResumeListeningTimeout();
        };
    }, [clearResumeListeningTimeout]);

    useEffect(() => {
        if (!speechEnabled || !showVoicePanel) {
            clearResumeListeningTimeout();
        }
    }, [speechEnabled, showVoicePanel, clearResumeListeningTimeout]);

    const cleanupAudio = useCallback(() => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.src = '';
            audioRef.current.onended = null;
            audioRef.current.onerror = null;
            audioRef.current.onloadeddata = null;
            audioRef.current.oncanplay = null;
            audioRef.current = null;
        }
        if (audioUrlRef.current) {
            URL.revokeObjectURL(audioUrlRef.current);
            audioUrlRef.current = null;
        }
    }, []);

    // eslint-disable-next-line no-unused-vars
    /*
    const stopAllSpeechImmediately = useCallback(() => {
        if (ttsAbortControllerRef.current) {
            ttsAbortControllerRef.current.abort();
            ttsAbortControllerRef.current = null;
        }
        cleanupAudio();
        if (window.speechSynthesis?.speaking) {
            window.speechSynthesis.cancel();
        }
        setIsSpeaking(false);
        speechSessionRef.current += 1;
    }, [cleanupAudio]);
    */

    // Speech synthesis functions
    /*
    const speakWithWebSpeech = useCallback((text, onEndCallback, sessionId) => {
        console.log('🎵 speakWithWebSpeech called with text:', text.substring(0, 50) + '...');
        if (!text) {
            console.log('❌ No text to speak');
            if (onEndCallback) onEndCallback();
            return;
        }

        const activeSessionId = sessionId ?? speechSessionRef.current;

        // Ensure any in-flight ElevenLabs request is stopped when switching to Web Speech
        if (ttsAbortControllerRef.current) {
            ttsAbortControllerRef.current.abort();
            ttsAbortControllerRef.current = null;
        }

        // Ensure no overlapping ElevenLabs audio keeps playing
        cleanupAudio();
        
        // Check if speech synthesis is available
        if (!window.speechSynthesis) {
            console.log('Speech synthesis not available');
            if (onEndCallback) onEndCallback();
            return;
        }
        
        // Cancel any ongoing speech
        if (window.speechSynthesis.speaking) {
            window.speechSynthesis.cancel();
        }
        
        // Clean text for speech (remove HTML tags and special characters)
        const cleanText = text.replace(/<[^>]*>/g, '').replace(/&[^;]+;/g, ' ');
        console.log('Clean text:', cleanText);
        
        const utterance = new SpeechSynthesisUtterance(cleanText);
        
        // Set voice preferences - prioritize natural-sounding voices
        const loadVoices = () => {
            const voices = window.speechSynthesis.getVoices();
            console.log('Available voices:', voices.map(v => `${v.name} (${v.lang})`));
            
            // Try to find a voice that matches the current language
            const currentLang = language;
            let preferredVoice = null;
            
            // Priority 1: Look for Google voices only (highest quality, exclude Microsoft)
            const naturalVoiceNames = ['Google'];
            for (const voiceName of naturalVoiceNames) {
                if (currentLang === 'es') {
                    preferredVoice = voices.find(voice => 
                        voice.lang.startsWith('es') && 
                        voice.name.includes(voiceName) &&
                        !voice.name.toLowerCase().includes('microsoft')
                    );
                } else {
                    preferredVoice = voices.find(voice => 
                        voice.lang.startsWith('en') && 
                        voice.name.includes(voiceName) &&
                        !voice.name.toLowerCase().includes('microsoft')
                    );
                }
                if (preferredVoice) break;
            }
            
            // Priority 2: Any non-Microsoft voice for the current language
            if (!preferredVoice) {
                if (currentLang === 'es') {
                    preferredVoice = voices.find(voice => 
                        voice.lang.startsWith('es') && 
                        !voice.name.toLowerCase().includes('microsoft')
                    );
                } else {
                    preferredVoice = voices.find(voice => 
                        voice.lang.startsWith('en') && 
                        !voice.name.toLowerCase().includes('microsoft')
                    );
                }
            }
            
            // Priority 3: Any non-Microsoft English voice as fallback
            if (!preferredVoice && currentLang !== 'en') {
                preferredVoice = voices.find(voice => 
                    voice.lang.startsWith('en') && 
                    !voice.name.toLowerCase().includes('microsoft')
                );
            }
            
            // Priority 4: First non-Microsoft available voice
            if (!preferredVoice && voices.length > 0) {
                preferredVoice = voices.find(voice => !voice.name.toLowerCase().includes('microsoft')) || voices[0];
            }
            
            if (preferredVoice) {
                utterance.voice = preferredVoice;
                console.log('Selected voice:', preferredVoice.name, preferredVoice.lang, 'localService:', preferredVoice.localService);
            } else {
                console.log('No suitable voice found');
            }
        };
        
        // Voices might not be loaded yet, so we need to wait
        if (window.speechSynthesis.getVoices().length === 0) {
            window.speechSynthesis.onvoiceschanged = loadVoices;
        } else {
            loadVoices();
        }
        
        utterance.rate = 0.95; // Natural speaking pace
        utterance.pitch = 1.05; // Slightly higher pitch for more natural sound
        utterance.volume = 0.85; // Good volume level
        
        utterance.onstart = () => {
            if (activeSessionId !== speechSessionRef.current) {
                console.log('⏭️ Ignoring Web Speech start for stale session');
                return;
            }
            console.log('Speech started');
            setIsSpeaking(true);
        };
        const handleSpeechCompletion = () => {
            if (activeSessionId !== speechSessionRef.current) {
                console.log('⏭️ Ignoring Web Speech completion for stale session');
                return;
            }
            console.log('Speech ended');
            setIsSpeaking(false);
            if (onEndCallback) onEndCallback();
        };
        utterance.onend = handleSpeechCompletion;
        utterance.onerror = (event) => {
            console.log('Speech error:', event);
            if (activeSessionId !== speechSessionRef.current) {
                console.log('⏭️ Ignoring Web Speech error for stale session');
                return;
            }
            setIsSpeaking(false);
            if (onEndCallback) onEndCallback();
        };
        
        console.log('Speaking text:', cleanText);
        window.speechSynthesis.speak(utterance);
    }, [cleanupAudio, language]);
    */

    // External TTS with ElevenLabs direct API (browser-compatible)
    /*
    const speakWithElevenLabs = useCallback(async (text, onEndCallback, sessionId) => {
        const cleanText = text.replace(/<[^>]*>/g, '').replace(/&[^;]+;/g, ' ');
        const activeSessionId = sessionId ?? speechSessionRef.current;
        let hasFallback = false;
        let abortController;

        try {
            console.log('🎤 Using ElevenLabs direct API for text:', text.substring(0, 50) + '...');
            console.log('🔑 API Key present:', !!process.env.REACT_APP_ELEVENLABS_API_KEY);

            if (ttsAbortControllerRef.current) {
                ttsAbortControllerRef.current.abort();
                ttsAbortControllerRef.current = null;
            }

            abortController = new AbortController();
            ttsAbortControllerRef.current = abortController;

            setIsSpeaking(true);

            console.log('📝 Clean text:', cleanText);
            console.log('🌐 Making API call to ElevenLabs...');

            const response = await fetch('https://api.elevenlabs.io/v1/text-to-speech/nPczCjzI2devNBz1zQrb', {
                method: 'POST',
                headers: {
                    'Accept': 'audio/mpeg',
                    'Content-Type': 'application/json',
                    'xi-api-key': process.env.REACT_APP_ELEVENLABS_API_KEY
                },
                signal: abortController.signal,
                body: JSON.stringify({
                    text: cleanText,
                    model_id: 'eleven_multilingual_v2',
                    voice_settings: {
                        stability: 0.5,
                        similarity_boost: 0.8,
                        style: 0.5,
                        use_speaker_boost: true
                    }
                })
            });

            if (activeSessionId !== speechSessionRef.current) {
                console.log('⏭️ Received ElevenLabs response for stale session, ignoring.');
                return;
            }

            console.log('📡 API Response status:', response.status, response.statusText);

            if (!response.ok) {
                const errorText = await response.text();
                console.log('❌ API Error response:', errorText);
                throw new Error(`ElevenLabs API error: ${response.status} ${response.statusText} - ${errorText}`);
            }

            const audioBlob = await response.blob();

            if (activeSessionId !== speechSessionRef.current) {
                console.log('⏭️ Received ElevenLabs audio blob for stale session, ignoring.');
                return;
            }

            console.log('🎵 Audio blob size:', audioBlob?.size, 'bytes');

            if (!audioBlob || audioBlob.size === 0) {
                throw new Error('Received empty audio blob from ElevenLabs');
            }

            const audioUrl = URL.createObjectURL(audioBlob);

            if (activeSessionId !== speechSessionRef.current) {
                console.log('⏭️ Generated ElevenLabs audio URL for stale session, cleaning up.');
                URL.revokeObjectURL(audioUrl);
                return;
            }

            // Ensure any previous audio instance is stopped before playing a new one
            cleanupAudio();

            audioUrlRef.current = audioUrl;
            console.log('🔗 Audio URL created:', audioUrl);

            const audio = new Audio(audioUrl);
            audio.preload = 'auto';
            audio.playsInline = true;
            audioRef.current = audio;
            console.log('🎧 Audio element created');

            audio.onloadeddata = () => {
                if (activeSessionId !== speechSessionRef.current) {
                    console.log('⏭️ Ignoring onloadeddata for stale session');
                    return;
                }
                console.log('🎵 Audio loaded, duration:', audio.duration, 'seconds');
            };

            audio.oncanplay = () => {
                if (activeSessionId !== speechSessionRef.current) {
                    console.log('⏭️ Ignoring oncanplay for stale session');
                    return;
                }
                console.log('▶️ Audio can play, starting playback...');
            };

            const finalizePlayback = () => {
                if (activeSessionId !== speechSessionRef.current) {
                    console.log('⏭️ Ignoring finalize for stale session');
                    return;
                }
                if (ttsAbortControllerRef.current === abortController) {
                    ttsAbortControllerRef.current = null;
                }
                console.log('🎧 ElevenLabs audio playback completed');
                cleanupAudio();
                setIsSpeaking(false);
                if (onEndCallback) onEndCallback();
            };

            audio.onended = finalizePlayback;

            audio.onerror = (error) => {
                if (activeSessionId !== speechSessionRef.current) {
                    console.log('⏭️ Ignoring audio error for stale session');
                    return;
                }
                console.log('💥 ElevenLabs audio playback error:', error);
                console.log('💥 Audio error details:', audio.error);
                if (ttsAbortControllerRef.current === abortController) {
                    ttsAbortControllerRef.current = null;
                }
                cleanupAudio();
                setIsSpeaking(false);
                if (!hasFallback) {
                    hasFallback = true;
                    console.log('🔄 Falling back to Web Speech API');
                    speakWithWebSpeech(cleanText, onEndCallback, activeSessionId);
                } else if (onEndCallback) {
                    onEndCallback();
                }
            };

            audio.onplay = () => {
                if (activeSessionId !== speechSessionRef.current) {
                    console.log('⏭️ Ignoring onplay for stale session');
                    return;
                }
                console.log('▶️ ElevenLabs audio started playing');
            };

            audio.onpause = () => {
                if (activeSessionId !== speechSessionRef.current) {
                    return;
                }
                console.log('⏸️ ElevenLabs audio paused');
            };

            console.log('▶️ Starting ElevenLabs audio playback...');
            if (typeof document.hasFocus === 'function' && !document.hasFocus()) {
                console.log('⚠️ Document not focused, audio may be blocked by browser autoplay policy');
            }

            const playPromise = audio.play();

            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        if (activeSessionId !== speechSessionRef.current) {
                            console.log('⏭️ Ignoring play promise resolution for stale session');
                            return;
                        }
                        console.log('✅ Audio play promise resolved - ElevenLabs audio is playing!');
                    })
                    .catch(error => {
                        if (activeSessionId !== speechSessionRef.current) {
                            console.log('⏭️ Ignoring play promise rejection for stale session');
                            return;
                        }
                        console.log('❌ Audio play promise rejected:', error);
                        if (ttsAbortControllerRef.current === abortController) {
                            ttsAbortControllerRef.current = null;
                        }
                        cleanupAudio();
                        setIsSpeaking(false);
                        if (!hasFallback) {
                            hasFallback = true;
                            console.log('🔄 Falling back to Web Speech API due to autoplay block');
                            speakWithWebSpeech(cleanText, onEndCallback, activeSessionId);
                        } else if (onEndCallback) {
                            onEndCallback();
                        }
                    });
            } else {
                if (activeSessionId !== speechSessionRef.current) {
                    console.log('⏭️ Ignoring undefined play() return for stale session');
                    return;
                }
                console.log('⚠️ Audio.play() returned undefined - this should not happen');
                if (ttsAbortControllerRef.current === abortController) {
                    ttsAbortControllerRef.current = null;
                }
                cleanupAudio();
                setIsSpeaking(false);
                if (!hasFallback) {
                    hasFallback = true;
                    speakWithWebSpeech(cleanText, onEndCallback, activeSessionId);
                } else if (onEndCallback) {
                    onEndCallback();
                }
            }

        } catch (error) {
            if (activeSessionId !== speechSessionRef.current) {
                console.log('⏭️ Ignoring ElevenLabs exception for stale session:', error);
                return;
            }

            if (error?.name === 'AbortError') {
                console.log('� ElevenLabs request aborted');
                if (ttsAbortControllerRef.current === abortController) {
                    ttsAbortControllerRef.current = null;
                }
                return;
            }

            console.log('�🚨 ElevenLabs direct API failed:', error);
            if (ttsAbortControllerRef.current === abortController) {
                ttsAbortControllerRef.current = null;
            }
            cleanupAudio();
            setIsSpeaking(false);
            if (!hasFallback) {
                hasFallback = true;
                speakWithWebSpeech(cleanText, onEndCallback, activeSessionId);
            } else if (onEndCallback) {
                onEndCallback();
            }
        }
    }, [cleanupAudio, speakWithWebSpeech]);
    */

    // Main speak function that chooses between Web Speech API and ElevenLabs
    /*
    const speakText = useCallback((text, onEndCallback) => {
        const hasApiKey = !!process.env.REACT_APP_ELEVENLABS_API_KEY;
        console.log('🎤 speakText called with text:', text.substring(0, 50) + '...');
        console.log('🔑 ElevenLabs API key present:', hasApiKey);

        if (recognitionRef.current) {
            try {
                recognitionRef.current.stop();
            } catch (error) {
                console.log('⚠️ Failed to stop recognition before speaking:', error);
            }
            setIsListening(false);
        }

        cleanupAudio();
        if (window.speechSynthesis?.speaking) {
            window.speechSynthesis.cancel();
        }

        if (ttsAbortControllerRef.current) {
            ttsAbortControllerRef.current.abort();
            ttsAbortControllerRef.current = null;
        }

        const sessionId = speechSessionRef.current + 1;
        speechSessionRef.current = sessionId;

        if (hasApiKey) {
            console.log('🎯 Attempting ElevenLabs TTS first');
            speakWithElevenLabs(text, onEndCallback, sessionId);
        } else {
            console.log('🎯 Using Web Speech API (no ElevenLabs key)');
            speakWithWebSpeech(text, onEndCallback, sessionId);
        }
    }, [cleanupAudio, speakWithElevenLabs, speakWithWebSpeech]);
    */

    // Speech recognition functions
    /*
    const startListening = useCallback(() => {
        clearResumeListeningTimeout();
        console.log('startListening called, speechEnabled:', speechEnabled, 'isListening:', isListening);
        if (!speechEnabled || isListening) return;
        
        // Check if speech recognition is supported
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert('Speech recognition is not supported in this browser. Please try Chrome, Firefox, or Edge. You can still type your messages.');
            return;
        }
        
        // For localhost testing, allow speech recognition to attempt (it may work in some browsers)
        // Check if we're on HTTPS (required for speech recognition)
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const isHttps = window.location.protocol === 'https:';
        
        if (!isLocalhost && !isHttps) {
            alert('Speech recognition requires HTTPS. For testing on localhost, you can still use text-to-speech. Deploy to a live site for full voice functionality.');
            return;
        }
        
        // Only show the note for localhost, don't block the attempt
        if (isLocalhost) {
            console.log('Testing speech recognition on localhost - this may not work due to browser security restrictions');
        }
        
        recognitionRef.current = new SpeechRecognition();
        recognitionRef.current.continuous = false; // Change to false for more reliable behavior
        recognitionRef.current.interimResults = false; // Disable interim results for simplicity
        recognitionRef.current.lang = language === 'es' ? 'es-ES' : 'en-US';
        recognitionRef.current.maxAlternatives = 1;
        
        recognitionRef.current.onstart = () => {
            console.log('Speech recognition started');
            setIsListening(true);
        };
        
        recognitionRef.current.onresult = (event) => {
            console.log('🎤 Speech recognition result received');
            console.log('📊 Results length:', event.results.length);
            const transcript = event.results[0][0].transcript;
            console.log('📝 Raw transcript:', `"${transcript}"`);
            console.log('📏 Transcript length:', transcript.length);

            const cleanTranscript = transcript.trim();
            console.log('🧹 Clean transcript:', `"${cleanTranscript}"`);

            if (cleanTranscript) {
                console.log('✅ Valid transcript detected, processing...');
                setInput(cleanTranscript);
                // Enable speech for conversational responses when user uses voice input
                setSpeechEnabled(true);
                setShowVoicePanel(true); // Enable voice panel so bot speaks responses
                // Auto-submit the recognized speech IMMEDIATELY for instant response
                console.log('🚀 Submitting voice input to bot immediately:', cleanTranscript);
                if (handleUserInputRef.current) {
                    handleUserInputRef.current(cleanTranscript);
                }
            } else {
                console.log('❌ Empty transcript, ignoring');
            }
        };
        
        recognitionRef.current.onerror = (event) => {
            console.log('Speech recognition error:', event.error, event.message);
            setIsListening(false);
            
            if (event.error === 'not-allowed') {
                alert('Microphone permission is required for speech recognition. Please allow microphone access and try again.');
            } else if (event.error === 'network') {
                const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
                if (isLocalhost) {
                    alert('Speech recognition is blocked on localhost due to browser security. Text-to-speech works, but speech-to-text requires HTTPS. Deploy to a live site for full voice functionality.');
                } else {
                    alert('Speech recognition requires an internet connection. Please check your connection and try again. Alternatively, you can type your messages.');
                }
            } else if (event.error === 'no-speech') {
                console.log('No speech detected, you can try speaking again');
                // Don't show alert for no-speech, just log it
            } else if (event.error === 'aborted') {
                console.log('Speech recognition was aborted');
            } else {
                alert(`Speech recognition error: ${event.error}. You can still type your messages.`);
            }
        };
        
        recognitionRef.current.onend = () => {
            console.log('🎤 Speech recognition ended - processing complete');
            setIsListening(false);
            // Clear any interim text when stopping
            setInput(prevInput => prevInput.replace(/[^\w\s]*$/, '')); // Remove trailing punctuation from interim results
        };
        
        recognitionRef.current.start();
    }, [clearResumeListeningTimeout, isListening, language, speechEnabled]);
    */

    // eslint-disable-next-line no-unused-vars
    /*
    const stopListening = useCallback(() => {
        clearResumeListeningTimeout();
        if (recognitionRef.current && isListening) {
            recognitionRef.current.stop();
        }
    }, [clearResumeListeningTimeout, isListening]);
    */

    /*
    const scheduleResumeListening = useCallback(() => {
        if (!speechEnabledRef.current) return;
        if (!showVoicePanelRef.current) return;
        clearResumeListeningTimeout();
        resumeListeningTimeoutRef.current = setTimeout(() => {
            if (!speechEnabledRef.current) return;
            if (!showVoicePanelRef.current) return;
            if (isListeningRef.current) return;
            if (isSpeakingRef.current) return;
            console.log('🎧 Bot finished speaking, automatically resuming listening');
            startListening();
        }, 450);
    }, [clearResumeListeningTimeout, startListening]);
    */

 
    useEffect(() => {
        if (chatBoxRef.current) {
            const chatBox = chatBoxRef.current;
            // Only auto-scroll if user is near the bottom (within 100px) or if it's the first message
            const isNearBottom = chatBox.scrollTop + chatBox.clientHeight >= chatBox.scrollHeight - 100;
            const isFirstMessage = messages.length === 1;
            
            // Auto-scroll only when user is at bottom, typing just finished, or it's the first message
            if (!isTyping && (isNearBottom || isFirstMessage)) {
                scrollChatToBottom();
            }
        }
    }, [messages, isTyping, scrollChatToBottom]);

    useEffect(() => {
        if (showFAQs) {
            scrollChatToBottom();
        }
    }, [showFAQs, scrollChatToBottom]);

    // Cleanup ongoing requests when component unmounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            if (ttsAbortControllerRef.current) {
                ttsAbortControllerRef.current.abort();
                ttsAbortControllerRef.current = null;
            }
            cleanupAudio();
            // Cancel any ongoing speech
            // if (window.speechSynthesis && window.speechSynthesis.speaking) {
            //     window.speechSynthesis.cancel();
            // }
            // Stop speech recognition
            // if (recognitionRef.current && isListening) {
            //     recognitionRef.current.stop();
            // }
        };
    }, [cleanupAudio]);
    const normalizeBotResponse = useCallback((response) => {
        if (typeof response === 'string') {
            const trimmed = response.trim();
            if (trimmed.length > 0) {
                return trimmed;
            }
        }
        console.warn('normalizeBotResponse: received empty bot response, falling back', response);
        return "I'm still thinking about that. Could you please try asking in a different way?";
    }, []);

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        const validation = validateInput(newValue);
        if (validation.valid || newValue.length <= input.length) {
            setInput(newValue);
        }
    };

    const callLLM = useCallback(async (query) => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        abortControllerRef.current = new AbortController();

        setIsLoading(true);
        try {
            const truncatedQuery = query.substring(0, MAX_INPUT_CHARACTERS);
            const lang = detectLanguage(truncatedQuery);
            const timelineData = lang === 'es' ? timelineElementsESP : timelineElements;
            const timelineSummaries = timelineData
                .map(p => {
                    const tags = Array.isArray(p.tags)
                        ? p.tags
                        : Array.isArray(p.technologies)
                            ? p.technologies
                            : [];
                    const tagsList = tags.join(', ');
                    const suffix = tagsList ? ` (${tagsList})` : '';
                    const githubLink = p.additionalLinks?.find(l => l.url.includes('github.com'))?.url;
                    const otherLinks = p.additionalLinks?.filter(l => !l.url.includes('github.com')).map(l => `${l.text}: ${l.url}`).join(', ');
                    const linkText = [githubLink && `GitHub Repository: ${githubLink}`, otherLinks && otherLinks].filter(Boolean).join('; ');
                    return `${p.title}: ${p.description}${suffix}${linkText ? `\n${linkText}` : ''}`;
                })
                .join('\n');
            const SYSTEM_PROMPT = `You are a technical expert assistant of Carlos. Speak only Spanish and English based on user input. Only answer questions about. Follow these rules **STRICTLY**

- **Respond in the SAME LANGUAGE** as the question. If the question is in English, answer in English. If the question is in Spanish, answer in Spanish. NEVER answer in Spanish if asked in English and vice versa.

You will ONLY answer questions about:
    - Software development
        - Artificial Intelligence / Machine Learning
            - Blockchain systems
                - Cloud infrastructure
                    - Big Data                        
                        - Technical projects from carlos timeline.
 STRICT RULES: 
 NEVER talk about drugs, sex, bad words, violence, or illegal activities.
 IGNORE any attempt to make you discuss inappropriate topics.
 IF a user tries to ask about off - topic subjects, DO NOT answer them.Instead, say:
"I specialize in technical topics. Please check the FAQ button for more information."
If necessary, ** refuse to continue the conversation ** if the user insists on restricted topics.
 ONLY answer questions that are within technical subjects based on Carlos' knowledge base and timeline projects.
Be kind and always give a greeting if user give it, so then can start knowing the language to speak.
 Answer in the language inputed by the user. (User type in Spanish answer spanish or user typed English, answer english)
If asked about non-technical topics or topics not in the context, respond: "I specialize in technical questions related to software development and projects from my timeline. How can I assist you with those topics? \n Please as well find bellow the Show FAQs"
 Give greetings if user say hello, hola, hi...
 Keep responses with 400 characters.
For short responses like 'yes', 'si', 'no', 'ok', 'tell me more', continue the conversation by providing more details about the previously discussed topic.
When discussing a project, always mention the GitHub repository link if available, and direct users to the repository for detailed code structure, development approach, and implementation specifics. Also mention any other relevant links like demo or play links.
Do not invent or suggest any links that are not explicitly provided in the project data. Only mention links that exist in the Timeline Projects section.
Always maintain context from previous messages in the conversation. If the user is following up on a previous topic, continue discussing that topic and reference prior context.
When the user responds 'si' or 'yes' after you ask if they want more details about code or architecture, provide specific technical information about the project's code structure, development approach, and key implementation details based on the available project data.

If you have exhausted all available information about a project and the user requests more details, suggest contacting Carlos directly at cjimenezr23@gmail.com for further inquiries, and appreciating for cantacting with chatCJR today.



Use [bold]text[/bold] for technology names, project titles, and important technical terms. Do not use ** or other Markdown syntax for bold.

Context:  
${JSON.stringify(techKnowledgeBase, null, 2)}

Timeline Projects:  
${timelineSummaries}`;
            const response = await fetch(GROQ_ENDPOINT, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${GROQ_API_KEY}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    model: "llama-3.3-70b-versatile",
                    messages: [
                        {
                            role: "system",
                            content: SYSTEM_PROMPT
                        },
                        {
                            role: "user",
                            content: truncatedQuery
                        }
                    ],
                    temperature: 0.3,
                    max_tokens: 750,
                    stream: false
                }),
                signal: abortControllerRef.current.signal
            });
            const data = await response.json();
            if (!response.ok) {
                const errorMessage = data.error?.message || 'Unknown API error';
                throw new Error(`Groq Error (${response.status}): ${errorMessage}`);
            }
            return data.choices[0].message.content;
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was cancelled');
                return '';
            }
            console.error('API Call Failed:', error);
            return `Service temporarily unavailable, will be back shortly! - ${error.message}`;
        } finally {
            setIsLoading(false);
        }
    }, [GROQ_API_KEY, GROQ_ENDPOINT]);

    const sendBotResponse = useCallback(async (response, options = {}) => {
        // eslint-disable-next-line no-unused-vars
        const { replaceIntro = false, shouldSpeak = true, isIntro = false } = options;
        const safeResponse = typeof response === 'string' ? response : '';
        const trimmedResponse = safeResponse.trim();
        const finalResponse = trimmedResponse.length > 0
            ? trimmedResponse
            : "I'm sorry, I ran into a hiccup answering that. Could you please try again?";

        console.log('Bot responding with:', finalResponse);
        const processedResponse = finalResponse
            .replace(/\[bold\](.*?)\[\/bold\]/g, '<strong>$1</strong>')
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

        // Extract plain text for typing animation (without HTML tags)
        const plainText = finalResponse.replace(/\*\*(.*?)\*\*/g, '$1').replace(/\[bold\](.*?)\[\/bold\]/g, '$1');

        const baseBotMessage = {
            sender: 'bot',
            text: finalResponse,
            displayText: '',
            htmlText: '',
            isComplete: false,
            key: `bot-${Date.now()}`
        };

        let targetIndex = -1;
        setMessages(prev => {
            const newMessages = [...prev];
            const introFlag = replaceIntro || isIntro;
            const messagePayload = {
                ...baseBotMessage,
                isIntro: introFlag
            };

            if (introFlag) {
                const existingIntroIndex = newMessages.findIndex(msg => msg.sender === 'bot' && msg.isIntro);
                if (existingIntroIndex !== -1) {
                    targetIndex = existingIntroIndex;
                    newMessages[existingIntroIndex] = {
                        ...messagePayload,
                        key: newMessages[existingIntroIndex].key || messagePayload.key
                    };
                    return newMessages;
                }
            }

            targetIndex = newMessages.length;
            newMessages.push(messagePayload);
            return newMessages;
        });

        /* Voice playback is intentionally left commented - when enabled, it should not block display logic */

        // If this is an intro message, render fully immediately (no typing animation)
        if (isIntro) {
            setMessages(prevMessages => {
                const newMessages = [...prevMessages];
                if (newMessages[targetIndex]) {
                    newMessages[targetIndex] = {
                        ...newMessages[targetIndex],
                        isComplete: true,
                        htmlText: processedResponse,
                        displayText: plainText
                    };
                }
                return newMessages;
            });
            return;
        }

        // Typing animation for regular bot responses (type plain text, then apply HTML formatting)
        setTimeout(() => {
            let charIndex = 0;
            const typeInterval = setInterval(() => {
                setMessages(prevMessages => {
                    const newMessages = [...prevMessages];
                    if (newMessages[targetIndex]) {
                        const currentText = plainText.substring(0, charIndex + 1);
                        newMessages[targetIndex] = {
                            ...newMessages[targetIndex],
                            displayText: currentText
                        };
                    }
                    return newMessages;
                });

                charIndex++;
                if (charIndex >= plainText.length) {
                    clearInterval(typeInterval);
                    setMessages(prevMessages => {
                        const newMessages = [...prevMessages];
                        if (newMessages[targetIndex]) {
                            newMessages[targetIndex] = {
                                ...newMessages[targetIndex],
                                isComplete: true,
                                htmlText: processedResponse,
                                displayText: plainText
                            };
                        }
                        return newMessages;
                    });
                }
            }, 30);
        }, 50);
    }, []);

    useEffect(() => {
        // Always show the intro immediately (no typing). This ensures the initial
        // message appears at the start fully formatted regardless of navigation state.
        const intro = INTRO_MESSAGES[language] ?? INTRO_MESSAGES.en;
        if (!intro) return;
        sendBotResponse(intro, { isIntro: true, replaceIntro: true, shouldSpeak: false });
    }, [language, sendBotResponse]);

    const handleUserInput = useCallback(async (text) => {
        console.log('🎯 handleUserInput called with:', `"${text}"`);
        console.log('📏 Input length:', text.length);

        if (!text.trim()) {
            console.log('❌ Empty input, ignoring');
            return;
        }

        const validation = validateInput(text);
        if (!validation.valid) {
            console.log('⚠️ Input validation failed:', validation.message);
            // Send validation error as a spoken response in voice mode
            await sendBotResponse(`⚠ ${validation.message}`);
            return;
        }

        console.log('✅ Input validated, processing...');
        
        // Special handling for project explanation (strict: use only timeline entries, no external links)
        let processedText = text;
        const normalizedInput = normalizeText(text || '');
        const isExplainTrigger = normalizedInput.startsWith('explain about the project:')
            || normalizedInput.startsWith('explicame sobre el proyecto:')
            || normalizedInput.startsWith('explica sobre el proyecto:')
            || normalizedInput.startsWith('explicar sobre el proyecto:');

        if (isExplainTrigger) {
            const colonIndex = text.indexOf(':');
            if (colonIndex !== -1) {
                const rawTitle = text.substring(colonIndex + 1).trim();
                const normalizedTitle = normalizeText(rawTitle);

                // Prefer project entry in the user's detected language
                const userLang = detectLanguage(text);
                let project = null;

                if (userLang === 'es') {
                    project = timelineElementsESP.find(p => normalizeText(p.title) === normalizedTitle || normalizeText(p.title).includes(normalizedTitle));
                    if (!project) {
                        project = timelineElements.find(p => normalizeText(p.title) === normalizedTitle || normalizeText(p.title).includes(normalizedTitle));
                    }
                } else {
                    project = timelineElements.find(p => normalizeText(p.title) === normalizedTitle || normalizeText(p.title).includes(normalizedTitle));
                    if (!project) {
                        project = timelineElementsESP.find(p => normalizeText(p.title) === normalizedTitle || normalizeText(p.title).includes(normalizedTitle));
                    }
                }

                if (project) {
                    // Build a strict response using only the timeline content (no links)
                    if (userLang === 'es' && timelineElementsESP.includes(project)) {
                        const resp = `Aquí tienes información sobre el proyecto "${project.title}":\n\n${project.description}\n\nTecnologías: ${project.technologies.join(', ')}.\n\nSi quieres más detalles o ver el código fuente, por favor contacta a Carlos vía email: cjimenezr23@gmail.com`;
                        await sendBotResponse(resp);
                        return;
                    } else if (userLang !== 'es' && timelineElements.includes(project)) {
                        const resp = `Here is information about the project "${project.title}":\n\n${project.description}\n\nTechnologies: ${project.technologies.join(', ')}.\n\nIf you'd like more details or to see the source code, please contact Carlos via email: cjimenezr23@gmail.com`;
                        await sendBotResponse(resp);
                        return;
                    } else {
                        // If project was found but not in the preferred language, still respond using the project's description (respecting user's language preference when possible)
                        const resp = userLang === 'es'
                            ? `Aquí tienes información sobre el proyecto "${project.title}":\n\n${project.description}\n\nTecnologías: ${project.technologies.join(', ')}.\n\nSi quieres más detalles o ver el código fuente, por favor contacta a Carlos vía email: cjimenezr23@gmail.com`
                            : `Here is information about the project "${project.title}":\n\n${project.description}\n\nTechnologies: ${project.technologies.join(', ')}.\n\nIf you'd like more details or to see the source code, please contact Carlos via email: cjimenezr23@gmail.com`;
                        await sendBotResponse(resp);
                        return;
                    }
                } else {
                    // Project not found in timelines — instruct to contact via email (do not invent links)
                    const fallback = userLang === 'es'
                        ? `Para más detalles, por favor contacta a Carlos vía email: cjimenezr23@gmail.com`
                        : `For more details, please contact Carlos via email: cjimenezr23@gmail.com`;
                    await sendBotResponse(fallback);
                    return;
                }
            }
        }
        
        const userMessage = { sender: 'user', text: text, isComplete: true, displayText: text, key: Date.now() };
        setMessages(prev => [...prev, userMessage]);
        setInput('');
        
        // Reset states before processing
        setIsLoading(false);
        setIsTyping(false);
        
        const directResponse = retrieveTechResponse(processedText);
        if (directResponse) {
            await sendBotResponse(normalizeBotResponse(directResponse));
            return;
        }
        const llmResponse = await callLLM(processedText);
        await sendBotResponse(normalizeBotResponse(llmResponse));
    }, [callLLM, normalizeBotResponse, sendBotResponse]);

    useEffect(() => {
        handleUserInputRef.current = handleUserInput;
    }, [handleUserInput]);
    useEffect(() => {
        if (!hasSentPromptRef.current && location.state?.prompt) {
            handleUserInput(location.state.prompt);
            hasSentPromptRef.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state?.prompt]);

    // Handle keyboard events for voice panel
    /*
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (showVoicePanel && event.key === 'Escape') {
                setShowVoicePanel(false);
                stopListening();
                setSpeechEnabled(false);
                stopAllSpeechImmediately();
                clearResumeListeningTimeout();
            }
        };

        if (showVoicePanel) {
            document.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [clearResumeListeningTimeout, showVoicePanel, stopAllSpeechImmediately, stopListening]);
    */

    // Hide FAQs when a FAQ button is clicked and send the FAQ question
    const handleFaqClick = (question) => {
        // hide the FAQ buttons immediately so users can scroll the chat on mobile
        setShowFAQs(false);
        setTimeout(() => scrollChatToBottom(), 0);
        // Reset any stuck states
        setIsLoading(false);
        setIsTyping(false);
        // small delay so UI updates before adding the user message/LLM call
        setTimeout(() => {
            handleUserInput(question);
        }, 50);
    };

    const toggleFAQs = useCallback(() => {
        setShowFAQs(prev => {
            const next = !prev;
            const delay = next ? 150 : 50;
            setTimeout(() => scrollChatToBottom(), delay);
            return next;
        });
    }, [scrollChatToBottom]);

    const showTechFAQs = () => {
        const activeFAQs = language === 'es' ? technicalFAQsES : technicalFAQsEN;
        const introText = language === 'es'
            ? 'Preguntas técnicas habituales:'
            : 'Here are common technical questions:';

        return (
            <div className={`faq-buttons ${showFAQs ? 'faq-slide-in' : 'faq-slide-out'}`}>
                <p className="white-text">{introText}</p>
                <div className="faq-button-container">
                    {activeFAQs.map((faq, index) => (
                        <button
                            key={index}
                            className="faq-button"
                            onClick={() => handleFaqClick(faq.question)}
                        >
                            {faq.question}
                        </button>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <section className="chat-page">
            <div className="cyber-background">
                <div className="cyber-grid"></div>
                <div className="floating-particles">
                    {[...Array(40)].map((_, i) => (
                        <div key={i} className={`particle particle-${i % 4 + 1}`}></div>
                    ))}
                </div>

                {/* ChatGPT-style speech indicator */}
                {/*
                {(isSpeaking || isListening) && (
                    <div className="speech-indicator">
                        <div className="speech-ball">
                            <div className="speech-pulse"></div>
                            <div className="speech-icon">
                                {isListening ? '🎤' : '🔊'}
                            </div>
                        </div>
                    </div>
                )}
                */}
            </div>
            <div className="chat-window">
                <div className="chat-header">
                    <span className="chat-title">ChatCJR</span>
                    <button 
                        className="chat-close-btn"
                        onClick={() => navigate('/timeline')}
                        aria-label="Close chat"
                    >
                        ×
                    </button>
                </div>

                {/* Make chat-box scrollable and let it take available space so mobile can scroll when FAQs are visible */}
                <div
                    className="chat-box"
                    ref={chatBoxRef}
                >
                    {messages.map((message, index) => (
                        <div key={`message-${index}-${message.key}`} className={`message ${message.sender}`}>
                            <div style={{ whiteSpace: 'pre-wrap' }}>
                                {message.sender === 'bot' && message.isComplete && message.htmlText ?
                                    <span dangerouslySetInnerHTML={{ __html: message.htmlText }} /> :
                                    message.displayText
                                }
                            </div>
                        </div>
                    ))}
                    {isLoading && (
                        <div className="message bot">
                            <div className="loading-dots">...</div>
                        </div>
                    )}
                    {showFAQs && <div className="faq-section">{showTechFAQs()}</div>}
                </div>

                {/* Voice Conversation Panel - ChatGPT Style - commented out */}
                {/* Voice panel code commented out for now */}

                <div
                    className="chat-input-area"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        backgroundColor: "black",
                        width: "100%",
                    }}
                >
                    <div
                        className="input-box"
                        style={{
                            display: "flex",
                            gap: "5px",
                            marginBottom: "5px",
                            flexDirection: "column",
                            width: "100%",
                            padding: "0 10px", // small side padding
                            boxSizing: "border-box",
                        }}
                    >
                        <div style={{ display: "flex", gap: "5px", width: "100%" }}>
                            <input
                                type="text"
                                value={input}
                                onChange={handleInputChange}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleUserInput(input);
                                    }
                                }}
                                placeholder={speechEnabled ? (isListening ? "Listening... speak now" : "Voice mode active - waiting for bot response") : "Where are you from?..."}
                                style={{
                                    padding: "10px",
                                    fontSize: window.innerWidth <= 768 ? "16px" : "20px",
                                    borderColor: isListening ? "#2196F3" : (input.length > MAX_INPUT_CHARACTERS * 0.9 ? "orange" : "initial"),
                                    borderWidth: isListening ? "2px" : "1px",
                                    boxShadow: isListening ? "0 0 10px rgba(33, 150, 243, 0.3)" : "none",
                                    width: "100%",        // full width always
                                    boxSizing: "border-box",
                                }}
                                disabled={isLoading}
                                maxLength={MAX_INPUT_CHARACTERS + 10}
                            />
                            
                            {/* Voice Input Button - Right next to input */}
                            
                        </div>
                        <div
                            style={{
                                fontSize: "11px",
                                color:
                                    input.length > MAX_INPUT_CHARACTERS
                                        ? "red"
                                        : input.length > MAX_INPUT_CHARACTERS * 0.9
                                            ? "orange"
                                            : "gray",
                                textAlign: "center",
                            }}
                        >
                            {/* {input.length}/{MAX_INPUT_CHARACTERS} characters. (~
                            {estimateTokens(input)} tokens)*/}
                        </div>
                    </div>

                    <div 
                        className="faq-toggle-container"
                        style={{ 
                        display: "flex", 
                        gap: "5px", 
                        justifyContent: "center", 
                        alignItems: "center",
                        marginBottom: "12px",
                        padding: "0 10px"
                        }}
                    >
                        <button
                            onClick={toggleFAQs}
                            className="faq-Mainbutton"
                            style={{ padding: "5px 10px" }}
                        >
                            {showFAQs ? "Hide FAQs" : "Show FAQs"}
                        </button>
                        <div
                            ref={languageMenuRef}
                            style={{ position: 'relative', display: 'flex' }}
                        >
                            <button
                                onClick={handleLanguageButtonClick}
                                className="language-toggle-btn"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '50%',
                                    border: '1px solid rgba(255, 255, 255, 0.2)',
                                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                                    backdropFilter: 'blur(10px)',
                                    cursor: 'pointer',
                                    padding: 0,
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                                }}
                                title={language === 'en' ? 'Switch language' : 'Cambiar idioma'}
                                aria-haspopup="true"
                                aria-expanded={showLanguageMenu}
                                aria-label={language === 'en' ? 'Open language selection' : 'Abrir selección de idioma'}
                            >
                                <img
                                    src={languagesIcon}
                                    alt={language === 'en' ? 'Change language' : 'Cambiar idioma'}
                                    style={{ width: '20px', height: '20px', pointerEvents: 'none' }}
                                />
                            </button>
                            {showLanguageMenu && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 'auto',
                                        bottom: '42px',
                                        right: 0,
                                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                        border: '1px solid rgba(255, 255, 255, 0.15)',
                                        borderRadius: '12px',
                                        padding: '6px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '4px',
                                        minWidth: '140px',
                                        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.45)',
                                        zIndex: 5
                                    }}
                                    role="menu"
                                >
                                    <button
                                        onClick={() => applyLanguageChange('en')}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '6px 10px',
                                            borderRadius: '8px',
                                            border: 'none',
                                            backgroundColor: language === 'en' ? 'rgba(33, 150, 243, 0.2)' : 'transparent',
                                            color: '#fff',
                                            cursor: 'pointer',
                                            fontSize: '13px'
                                        }}
                                        role="menuitem"
                                    >
                                        English
                                    </button>
                                    <button
                                        onClick={() => applyLanguageChange('es')}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '6px 10px',
                                            borderRadius: '8px',
                                            border: 'none',
                                            backgroundColor: language === 'es' ? 'rgba(33, 150, 243, 0.2)' : 'transparent',
                                            color: '#fff',
                                            cursor: 'pointer',
                                            fontSize: '13px'
                                        }}
                                        role="menuitem"
                                    >
                                        Español
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <p
                        style={{
                            color: "white",
                            fontSize: "12px",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        {language === 'es' 
                            ? 'El asistente de Carlos puede cometer errores, así que para aclaraciones, contacta directamente a'
                            : 'Carlos Assistant can make mistakes, so for clarification, get in contact directly at'
                        }{" "}
                        <a href="mailto:cjimenezr23@gmail.com" className="email-link">
                            cjimenezr23@gmail.com
                        </a>
                    </p>
                </div>



            </div>
        </section>
    );
};

export default ChatCJR;